/**
 * Decode ChainLock signers bitmap
 * Converts hex bitmap to array of indices that signed
 */
export function decodeSignersBitmap(hexBitmap: string): number[] {
  if (!hexBitmap) return [];

  const binary = parseInt(hexBitmap, 16).toString(2).padStart(hexBitmap.length * 4, '0');
  const indices: number[] = [];

  // Read bits from right to left (LSB first)
  for (let i = 0; i < binary.length; i++) {
    if (binary[binary.length - 1 - i] === '1') {
      indices.push(i);
    }
  }

  return indices;
}

/**
 * Count number of signers from bitmap
 */
export function countSigners(hexBitmap: string): number {
  if (!hexBitmap) return 0;
  return decodeSignersBitmap(hexBitmap).length;
}

/**
 * Calculate percentage of signers
 */
export function calculateSignerPercentage(hexBitmap: string, totalCount: number): number {
  if (!hexBitmap || totalCount === 0) return 0;
  const signerCount = countSigners(hexBitmap);
  return Math.round((signerCount / totalCount) * 100);
}
